module.exports = __webpack_public_path__ + "static/media/ru.af31e644.svg";